// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"c181d6f7","147":"4e4592b8","367":"86b0a157","376":"ba7f75ec","483":"1a066322","488":"83fbfb27","528":"08ccf89b","591":"aea3e18a","636":"eff4ab61","769":"a83f775a","813":"f6ae210f","960":"5a8cd87b"}[chunkId] + ".chunk.js";
};